import { ImageTransform } from '../image'

enum GoodsType {
  ONE_PRODUCT = 'one-product',
  TWO_PRODUCTS = 'two-products',
  THREE_PRODUCTS = 'three-products',
  FOUR_PRODUCTS = 'four-products',
  SIX_PRODUCTS = 'six-products',
}

enum GoodsItemLinkType {
  AFFILIATE = 'affiliate',
  DIRECT = 'direct',
}

interface GoodsItem {
  title: string
  price: string
  caption: string
  alt: string
  source: string
  link: string
  url: string
  label: string
  button: string
  id: number
  image_transform_id: number | null
  affiliate_url: string | null
  imageTransform: ImageTransform | null
  link_type: GoodsItemLinkType
}

type GoodsWidget = GoodsItem[]

export { GoodsType, GoodsItemLinkType }

export type { GoodsWidget, GoodsItem }
